import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from "@/layout"
const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "Home",
          index: 0,
        },
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/product/index.vue"),
        meta: {
          title: "product",
          index: 1,
        },
      },
      {
        path: "/productDetail",
        name: "productDetail",
        component: () => import("@/views/product/productDetail.vue"),
        meta: {
          title: "productDetail",

        },
      },
      {
        path: "/solution",
        name: "solution",
        component: () => import("@/views/solution/index.vue"),
        meta: {
          title: "solution",
          index: 2,
        },
      },
      {
        path: "/solutionDetail",
        name: "solutionDetail",
        component: () => import("@/views/solution/detail.vue"),
        meta: {
          title: "solutionDetail",
          index: 2,
        },
      },
      {
        path: "/universe",
        name: "universe",
        component: () => import("@/views/universe/index.vue"),
        meta: {
          title: "universe",
          index: 3,
        },
      },
      {
        path: "/our",
        name: "our",
        component: () => import("@/views/our/index.vue"),
        meta: {
          title: "our",
          index: 4,
        },
      },
      {
        path: "/call",
        name: "call",
        component: () => import("@/views/call/index.vue"),
        meta: {
          title: "call",
          index: 5,
        },
      },
    ],
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router
